import React, { Fragment }  from "react";

import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const ProgressBar = ({gradientId, strokeWidth, startColor, endColor, percentage, children})=> {

  return (
    <Fragment>
      <svg style={{ height: 0, width: 0, position: 'absolute' }}>
        <defs>
          <linearGradient id={gradientId} >
            <stop offset="0%" stopColor={startColor} />
            <stop offset="100%" stopColor={endColor} />
          </linearGradient>
        </defs>
      </svg>

      <div className="progress-bar-wrapper">
        <div className="bar"> <CircularProgressbar strokeWidth={strokeWidth || 5}  value={percentage} /> </div>
        <div className="content"> {children} </div>
      </div>
    </Fragment>
  );
}

export default ProgressBar;
